import { yaTag } from '../middleware/yandex/yandex.tag';

$(() => {
  const body = document.querySelector('body');
  const { hostname } = document.location;
  const { referrer } = document;

  if (body.classList.contains('shop-product')) {
    (async function () {
      await yaTag('PRODUCT_PAGE_ONLOAD', null, '');
    }());

    if (!referrer.includes(hostname)) {
      (async function () {
        await yaTag('PRODUCT_PAGE_DIRECT', null, '');
      }());
    }
  }

  // product gallery
  $('.product-gallery-container').each((_, container) => {
    const sliderContainer = $(container);
    const mainSwiperContainer = sliderContainer.find('.swiper-product');
    const thumbsSwiperContainer = sliderContainer.find('.swiper-product-thumbnails');
    const slides = mainSwiperContainer.find('.swiper-slide');

    if (slides.length <= 3) {
      thumbsSwiperContainer.addClass('no-arrow');
      $('.swiper-button-next, .swiper-button-prev').hide();
    }

    const thumbsSwiper = new Swiper(thumbsSwiperContainer, {
      css: true,
      slidesPerView: slides.length >= 3 ? 3 : 2,
      loop: slides.length > 3,
      allowTouchMove: slides.length > 3,
      loopedSlides: 3,
      breakpointsInverse: true,
      // touchRatio: 0.2,
      // freeMode: true,
      breakpoints: {
        // when window width is >= 1200px
        1200: {
          slidesPerView: 3,
          direction: 'vertical',
        },
      },

      on: {
        resize() {
          thumbsSwiper.update();
        },
      },
    });

    const nav = {
      nextEl: '.swiper-product-thumbnails-button-next',
      prevEl: '.swiper-product-thumbnails-button-prev',
    };

    if (mainSwiperContainer !== null) {
      const mainSlider = new Swiper(mainSwiperContainer, {
        hashNavigation:
          slides.length > 3
            ? {
              replaceState: true,
              watchState: true,
            }
            : false,
        css: true,
        preloadImages: true,
        updateOnImagesReady: true,
        lazy: true,
        slidesPerView: 1,
        spaceBetween: 10,
        // touchRatio: slides.length > 1 ? 1 : 0,
        loop: slides.length > 3,
        loopedSlides: 3,
        navigation: nav,
        thumbs:
          slides.length <= 3
            ? {
              swiper: thumbsSwiper,
            }
            : {},
      });

      if (thumbsSwiperContainer[0] !== undefined && slides.length > 3) {
        mainSlider.controller.control = thumbsSwiper;
        thumbsSwiper.controller.control = mainSlider;
      }

      if (slides.length <= 3) {
        thumbsSwiper.on('slideChange', () => {
          mainSlider.slideTo(thumbsSwiper.activeIndex);
        });
      }
    }
  });
});
